/* eslint-disable react-hooks/rules-of-hooks */
import { UpdateAccountSourcesByUserIdParams } from '@lessonPlanner/commons';

export const updateAccountSources = async (
  params: UpdateAccountSourcesByUserIdParams,
): Promise<unknown> => {
  const response = await fetch('/api/update-sources', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch account sources');
  }

  const accountSources = await response.json();
  return accountSources;
};
